/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

import { Stack } from '@fluentui/react/lib/Stack';
import { CustomizerContext } from '@fluentui/react/lib/Utilities';
import * as React from 'react';
import { getThemedIcon, IconName } from '../../../resources/icons/Icons';
import { getAppHost } from '../../../utilities/TeamsUtils';
import { Recipient } from '../../../views/Esign/RecipientList';
import { MobileActionTableItem } from '../../components/MobileActionTableItem/MobileActionTableItem';
import { recipientListInputStackStyles } from './RecipientList.styles';

export interface RecipientListInputProps {
    onClick: () => void;
    recipients: Recipient[];
}

export const RecipientListInput: React.FC<RecipientListInputProps> = (props: RecipientListInputProps): JSX.Element => {
    const { onClick, recipients } = props;

    const host = getAppHost();
    const loc = host.getLocale();
    const theme = React.useContext(CustomizerContext).customizations.settings.theme;

    const recipientNames = recipients.map((recipient: Recipient): string => recipient.name).join(',');
    const elementText = recipientNames ? recipientNames : loc.strings.mobile_recipient_input_placeholder;

    const actionElement = (
        <Stack onClick={onClick} horizontal={true} verticalAlign={'center'}>
            <Stack.Item styles={recipientListInputStackStyles(theme)}>{elementText}</Stack.Item>
        </Stack>
    );

    return (
        <MobileActionTableItem
            unselectedIcon={getThemedIcon(IconName.addPeopleNonSelected)}
            selectedIcon={getThemedIcon(IconName.addPeople)}
            actionElement={actionElement}
        />
    );
};
